import { useEffect } from "react";

const BASE = "https://privatecredit.com.au";
const DEFAULT_TITLE = "Australia's Independent Private Credit Guide";
const DEFAULT_DESC =
  "Independent guide to Australia's A$234.5b private credit market: manager directory, ASIC REP 814 explainers, market data, press feed and borrower enquiry routing.";
const INDEX_FOLLOW = "index, follow, max-image-preview:large, max-snippet:-1";

const setMeta = (selector, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(el.tagName === "LINK" ? "href" : "content", value);
};

const applySeo = ({ title, desc, path, noindex }) => {
  document.title = title;
  setMeta('meta[name="description"]', desc);
  setMeta('meta[name="robots"]', noindex ? "noindex, nofollow" : INDEX_FOLLOW);
  setMeta('link[rel="canonical"]', `${BASE}${path}`);
  setMeta('meta[property="og:title"]', title);
  setMeta('meta[property="og:description"]', desc);
  setMeta('meta[property="og:url"]', `${BASE}${path}`);
  setMeta('meta[name="twitter:title"]', title);
  setMeta('meta[name="twitter:description"]', desc);
};

// Mutates the single static set of SEO tags in place — no duplicate meta tags,
// static head stays intact as the floor for non-JS crawlers.
export const Seo = ({ title, description, path = "/", noindex = false }) => {
  const fullTitle = title ? `${title} | PrivateCredit.com.au` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;

  useEffect(() => {
    applySeo({ title: fullTitle, desc, path, noindex });
    return () => applySeo({ title: DEFAULT_TITLE, desc: DEFAULT_DESC, path: "/", noindex: false });
  }, [fullTitle, desc, path, noindex]);

  return null;
};

// Injects a JSON-LD script block for the lifetime of the component.
export const JsonLd = ({ data }) => {
  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => el.remove();
  }, [data]);
  return null;
};
